import React from 'react';

import ContactSocial from './../contact/contactInfo/contactSocial';

const FooterContact = () => {

    return (
        <>
            {/* <VisiterCount /> */}
            {/* <ContactInfo /> */}
            <ContactSocial iconPadding={true} />
        </>
    )
}

export default FooterContact;